export default __webpack_public_path__ + "static/media/logo02.ef3dc476.svg";